import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './EmailSignature.scss';

function useCopyElement() {
    const [isCopied, setIsCopied] = useState(false);
    const ref = useRef();

    function onCopy(e) {
        e.preventDefault();

        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(ref.current);
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');

        setIsCopied(true);

        selection.removeAllRanges();

        setTimeout(() => setIsCopied(false), 2000);
    }

    return { ref, isCopied, onCopy };
}

export default function EmailSignature({ url, photo, username }) {
    const { t } = useTranslation('cards');
    const { ref, isCopied, onCopy } = useCopyElement();

    return (
        <div>
            <div className={styles.sectionBlock}>
                <p className={styles.headingInstruction}>{t('pageShare.emailSign_info')}</p>
                <div
                    onClick={onCopy}
                    ref={ref}
                    data-success={t('common:labels.copied')}
                    data-block="copy_signature"
                    className={classNames(styles.copy, { [styles.copied]: isCopied })}
                >
                    <a href={url} style={{ color: 'black', textDecoration: 'none', pointerEvents: 'none' }}>
                        <img
                            src={photo}
                            style={{
                                width: '45px',
                                height: '45px',
                                borderRadius: '45px',
                                float: 'left',
                                marginRight: '16px',
                                marginTop: '-5px',
                            }}
                        />
                        <span
                            style={{
                                fontFamily: 'sans-serif',
                                background: 'transparent',
                                fontSize: '14px',
                                fontWeight: '500',
                            }}
                        >
                            {username}
                        </span>
                        <span
                            style={{
                                fontFamily: 'sans-serif',
                                background: 'transparent',
                                fontSize: '12px',
                                fontWeight: '300',
                                color: '#3897F0',
                                marginTop: '6px',
                                display: 'block',
                            }}
                        >
                            {url}
                        </span>
                    </a>
                </div>
            </div>
        </div>
    );
}

EmailSignature.propTypes = {
    url: PropTypes.string.isRequired,
    photo: PropTypes.string,
    username: PropTypes.string,
};
